<template>
  <BaseModalSmall
    useForm
    @submit="submit"
    @close="$emit('close')"
  >
    <Flex direction="column">
      <BaseHeading>{{ $t('password_confirmation.heading') }}</BaseHeading>
      <BaseAlert
        color="warning"
        :text="$t('password_confirmation.description')"
      />
      <BaseInput
        v-model="password"
        :label="$t('password_confirmation.label')"
        type="password"
        required
        :error="invalidPassword ? $t('account.auth.two_factor_settings.errors.password') : undefined"
        v-test="'password-confirmation-input'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="$emit('close')"
        v-test="'password-confirmation-cancel'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        submitForm
        :loading="loading"
        v-test="'password-confirmation-submit'"
      >
        {{ $t('global.actions.confirm') }}
      </BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script
  lang="ts"
  setup
>
import { ref } from 'vue';

defineProps<{
  invalidPassword: boolean;
  loading: boolean;
}>();

const emit = defineEmits(['close', 'submit']);

const password = ref('');

const submit = () => {
  emit('submit', password.value);
};
</script>
